import { ArrowUpDown, MoreHorizontal } from "lucide-react"
import { Checkbox } from "@radix-ui/react-checkbox"
import RadixButton from "../ui/RadixButton"
import RadixDropdownMenu from "../ui/RadixDropdownMenu"

// This type defines the shape of our user data
export const userColumns = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && "indeterminate")
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "id",
    header: ({ column }) => {
      return (
        <RadixButton
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="h-8 px-2 lg:px-3"
        >
          ID
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </RadixButton>
      )
    },
    cell: ({ row }) => (
      <div className="font-medium">{row.getValue("id")}</div>
    ),
  },
  {
    accessorKey: "username",
    header: ({ column }) => {
      return (
        <RadixButton
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="h-8 px-2 lg:px-3"
        >
          Username
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </RadixButton>
      )
    },
    cell: ({ row }) => (
      <div className="font-medium">{row.getValue("username") || "N/A"}</div>
    ),
  },
  {
    accessorKey: "emails",
    header: "Email",
    cell: ({ row }) => {
      const emails = row.getValue("emails")
      if (emails && emails.length > 0) {
        return (
          <div className="flex flex-col space-y-1">
            {emails.map((email, index) => (
              <span key={index} className="text-blue-600 text-sm">{email}</span>
            ))}
          </div>
        )
      }
      return <span className="text-gray-400 text-sm">No email</span>
    },
  },
  {
    accessorKey: "phone",
    header: "Phone",
    cell: ({ row }) => (
      <div className="text-sm">{row.getValue("phone") || "N/A"}</div>
    ),
  },

  {
    id: "actions",
    enableHiding: false,
    cell: ({ row }) => {
      const user = row.original

      const menuItems = [
        {
          label: "Actions",
          type: "label"
        },
        {
          label: "Copy user ID",
          onClick: () => navigator.clipboard.writeText(user.id.toString())
        },
        { type: "separator" },
        {
          label: "View user details",
          onClick: () => console.log("View details for user:", user.id)
        },
        {
          label: "Edit user",
          onClick: () => console.log("Edit user:", user.id)
        },
        {
          label: "Block user",
          onClick: () => console.log("Block user:", user.id),
          className: "text-red-600"
        }
      ]

      return (
        <RadixDropdownMenu
          trigger={
            <RadixButton variant="ghost" className="h-8 w-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="h-4 w-4" />
            </RadixButton>
          }
          items={menuItems}
          align="end"
        />
      )
    },
  },
]
